import { api, postApi } from "./api";
import type { DoneQuest, Quest } from "../types";
export { dailyRewardEligible, restsToday } from "./daily";

// Persist quest completions to the server (mirrors the finance forms' pattern:
// the store updates optimistically, these fire in the background). The engine
// awards XP + marks the quest done, so it survives a refresh and shows in the log.
// `extra` carries a recurring checklist's cycle ({ recur, next }) so the engine
// brings it back on time even when it was finished from the button, not a tick.
export const apiComplete = (id: string, extra: Record<string, unknown> = {}): Promise<Response> =>
  postApi("/api/quests", { action: "complete", id, ...extra });
export const apiUncomplete = (id: string): Promise<Response> => postApi("/api/quests", { action: "uncomplete", id });
// The daily reward. The server owns the gate and the once-per-day rule.
export const apiClaim = (): Promise<Response> => postApi("/api/quests", { action: "claim" });

// The Quest Log - every completed quest, newest first.
export const fetchQuestLog = (): Promise<DoneQuest[]> => api<DoneQuest[]>("/api/quests?status=done");

// A quest can serve several main quests. `main` is the primary (what the chip
// shows); `mains` is the full list. Read membership through these two so a
// multi-parent quest counts on every main-quest page it belongs to.
export const questMains = (q: Quest): string[] =>
  q.mains && q.mains.length > 0 ? q.mains : q.main ? [q.main] : [];
export const servesMain = (q: Quest, id: string): boolean => questMains(q).includes(id);
